import React, { PureComponent } from 'react';
import _includes from 'lodash/includes';
import dayjs from 'dayjs';
import DayPicker from 'react-day-picker';
import _union from 'lodash/union';
import _last from 'lodash/last';
import _head from 'lodash/head';
import _uniq from 'lodash/uniq';
import _map from 'lodash/map';
import { connect } from 'react-redux';


class SimpleCalender extends PureComponent {

  constructor(props){
    super(props);

    this.state = {
      selectedDay:null,
      activeDay:"",
      minDate:"",
      maxDate:"",
      currentDate:"",
      enabledDates:[],
      enabledDateOriginal:[],
      disabledDate:[],
      disabledDateOriginal:[],
      selectdropdownValue:"",
      selectdropdownMonths:[],
      duration:0,
      months:["January", "February", "March","April","May","June","July","August","September","October","November","December"],
      isYearOpen:false,
      ready:false
    }

    this.handleYearMonthChange = this.handleYearMonthChange.bind(this);
    this.documentClickHandler = this.documentClickHandler.bind(this);
  }

  componentDidMount(){

    document.body.addEventListener('click', this.documentClickHandler);

    const { departures } = this.props;

    let _minDate = dayjs(_head(departures)).toDate();
    let _maxDate = dayjs(_last(departures)).toDate();
    let _tourDates = _map(departures, (n) =>{ return dayjs(n).toDate() });
    
    this.setState({
      minDate:_minDate,
      maxDate:_maxDate,
      currentDate:_minDate,
      enabledDates: _tourDates,
      enabledDateOriginal: _tourDates,
      disabledDate:[],
      disabledDateOriginal:[],
      selectdropdownMonths:this.populateMonthsSelector(_maxDate)
    }, () => {
       this.setState({ready:true});
    });

  }

  componentWillUnmount(){
    document.body.removeEventListener('click', this.documentClickHandler);
  }

  documentClickHandler(e){
    try{
      if(e.target.offsetParent.className !== "filterDropdown basket" && e.target.offsetParent.className !== "calender"){
        if(this.state.isYearOpen) this.setState({isYearOpen: false});
      }
    }catch(e){}

  }

 
  populateMonthsSelector(maxDate){


    const { months } = this.state;
    const { departures, isPopularItineraries } = this.props;

    if(maxDate !== ""){
      
      if(isPopularItineraries){
        let departuresDates = [];

        for(var j = 0; j < departures.length; j++){
          departuresDates.push(months[ dayjs(departures[j]).month() ] + " " +  dayjs(departures[j]).year() );
        }

        return _uniq(departuresDates);
      }  

      if(!isPopularItineraries){
        let thisYear = [];
        let nextYear = [];

        for(var i = 0; i < departures[0].months.length; i++){
          thisYear.push(months[parseInt(departures[0].months[i], 10)-1] + " " +  departures[0].year);
        }

        if(departures.length > 1){
          for(var ii = 0; ii < departures[1].months.length; ii++){
            nextYear.push(months[parseInt(departures[1].months[ii], 10)-1] + " " +  departures[1].year);
          }
        }
        
        return _union(thisYear, nextYear);
      }

    }else{
      return [];
    }
  }


  handleDayClick = (day, { selected }) => {

    const selectedDay = dayjs(day).format('YYYY-MM-DD');
    const notAvailable = _includes(this.state.disabledDateOriginal, selectedDay);

    if(notAvailable) return;

    this.setState({
      selectedDay: selected ? undefined : day
    });

    
    if(this.state.activeDay !== selectedDay){
      this.setState({activeDay:selectedDay});
      document.body.dispatchEvent(new CustomEvent('CITY_START_DATE_CLICK', { detail: selectedDay }));

    }else{
      this.setState({activeDay:""});
      document.body.dispatchEvent(new CustomEvent('CITY_START_DATE_CLICK', { detail: "" }));
    }
    
  };

  handleMonthClick = (day) => {
    this.setState({
      selectdropdownValue:dayjs(day).format('MMMM YYYY'),
      currentDate:dayjs(day).toDate()
    });
    
  }
  

  renderDay(day){
    const date = day.getDate();

    return(
      <div>
        {date}
      </div>
    )
  }

  handleYearMonthChange = (e, value) => {

    const _month = value.split(" ")[0];
    const _year = value.split(" ")[1];
    const _monthIndex = this.state.months.indexOf(_month);

    // Set the current drop down menu value and current calender date
    this.setState({
      selectdropdownValue:value,
      currentDate:new Date(_year, _monthIndex),
      isYearOpen:false,
      activeDay:""
    });

  }

  onYearClick(e){
    e.preventDefault();
    this.setState({isYearOpen:!this.state.isYearOpen});
  }

  YearMonthForm(){
    const { isYearOpen, selectdropdownMonths } = this.state;

    const currentMonth = dayjs(this.state.currentDate).format('MMMM YYYY');

    return (
      <form className="DayPicker-Caption">
         <div className="clearfix mxn2">
          <div className="col-6 sm-col-4 lg-col-3 px2 mx-auto">
            <div className="filterDropdown basket">
              <div className="clearfix mxn2">
                <div className="col-12 px2 mx-auto">
                  <a onClick={ e => this.onYearClick(e) } className="filterDropdown-btn calender">
                  {currentMonth}

                  <svg width="1792" height="1792" viewBox="0 0 1792 1792" xmlns="http://www.w3.org/2000/svg" className={`${isYearOpen ? 'active' : ''}`}>
                    <path fill="#ff6700" d="M1683 808l-742 741q-19 19-45 19t-45-19L109 808q-19-19-19-45.5t19-45.5l166-165q19-19 45-19t45 19l531 531 531-531q19-19 45-19t45 19l166 165q19 19 19 45.5t-19 45.5z"/>
                  </svg>

                  <i className={`fa fa-chevron-down ${isYearOpen ? 'active' : ''}`} aria-hidden="true"></i>
                  </a>
                </div>
                <div className="col col-12 px2 mx-auto">
                  <ul className="calender" style={{display: isYearOpen ? 'block':'none' }}>
                    {
                      selectdropdownMonths.map((value, index) => {
                        return (
                          <li
                            value={value}
                            onClick={e => this.handleYearMonthChange(e, value)}
                            key={index}>{value}
                          </li>
                        )
                      })
                    }
                  </ul>
                </div>
              </div>
            </div>
         </div>
        </div>

      </form>
    )
  }


  populateDisabledDate(formatted=true, selectedDay = ""){
 
    let thisYear = [];
    let nextYear = [];

    const { departures } = this.props;

    const lastMonthDate = dayjs(_last(departures).last).get('date')+1;
    const lastDayOfMonth = dayjs(_last(departures).last).endOf('month').get('date')+1;
    const currentMonthDate = (selectedDay === "") ? dayjs().get('date') : selectedDay.get('date');

    for(var i = 0; i < currentMonthDate; i++){
      if(formatted){
        (selectedDay === "") ? thisYear.push(dayjs().date(i).toDate()) : thisYear.push(dayjs(selectedDay).date(i).toDate())
      }else{
        (selectedDay === "") ? thisYear.push(dayjs().date(i).format('YYYY-MM-DD')) : thisYear.push(dayjs(selectedDay).date(i).format('YYYY-MM-DD'))
      }
    }

    for(var ii = lastMonthDate; ii < lastDayOfMonth; ii++){
      if(formatted){
        nextYear.push(dayjs(_last(departures).last).date(ii).toDate())
      }else{
        nextYear.push(dayjs(_last(departures).last).date(ii).format('YYYY-MM-DD'))
      }
    }

    return _union(thisYear, nextYear);
  }


  render(){

    const { minDate, maxDate, selectedDay, currentDate, ready, disabledDate, enabledDates } = this.state;
  
  
    if(ready){
      return (
        <DayPicker
          className={`simple-calender-pap`}
          showOutsideDays
          firstDayOfWeek={1}
          numberOfMonths={1}
          fromMonth={minDate}
          toMonth={maxDate}
          month={currentDate}
          value={selectedDay}
          selectedDays={selectedDay}
          onDayClick={this.handleDayClick}
          onMonthChange={this.handleMonthClick}
          canChangeMonth={true}
          renderDay={this.renderDay.bind(this)}
          modifiers={{ 
            available:enabledDates,
            outside:disabledDate
          }}
          captionElement={this.YearMonthForm.bind(this)}
          weekdaysShort={['SUN', 'MON', 'TUES', 'WED', 'THU', 'FRI', 'SAT']}
        />
      )
    }else{
      return null
    }      
  }

}


const mapStateToProps = state => {
  return{
    departures:state.departures
  }
}

export default connect(mapStateToProps, null)(SimpleCalender);
